export const sliderItems = [
  {
    id: 1,
    img: 'https://images.pexels.com/photos/4062467/pexels-photo-4062467.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
    title: 'NEW ARRIVALS',
    desc: 'Shop now to get 40% off on new Arrivals',
    bg: 'f5fafd',
  },
  {
    id: 2,
    img: 'https://images.pexels.com/photos/3768591/pexels-photo-3768591.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
    title: 'SUMMER SALE',
    desc: 'Shop now to get 40% off on new Arrivals',
    bg: 'fcf1ed',
  },
  {
    id: 3,
    img: 'https://images.pexels.com/photos/1458867/pexels-photo-1458867.jpeg',
    title: 'WINTER SALE',
    desc: 'Shop now to get 40% off on new Arrivals',
    bg: 'fbf0f4',
  },
];


export const CatThumbs = [
  {
    id: 1,
    img: 'https://images.pexels.com/photos/2735970/pexels-photo-2735970.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
    title: 'Jewellery',
  },
  {
    id: 2,
    img: 'https://images.pexels.com/photos/3345882/pexels-photo-3345882.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
    title: 'Electronics',
  },
  {
    id: 3,
    img: 'https://images.pexels.com/photos/14341147/pexels-photo-14341147.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
    title: "Men's Clothing",
  },
  {
    id: 4,
    img: 'https://images.pexels.com/photos/8217860/pexels-photo-8217860.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
    title: "Men's Clothing",
  },
];